import classNames from 'classnames';
import BannerCenteredContent from 'components/Banner/BannerCenteredContent';
import useStylesTitle from 'components/Banner/BodyTextWithDoubleCTA/Content/Title/styles';
import useStylesContent from 'components/Banner/BodyTextWithDoubleCTA/Content/styles';
import useStyles from 'components/Banner/BodyTextWithDoubleCTA/styles';

function BodyTextWithDoubleCTAFallback(fallbackClassName) {
  const styles = useStyles();
  const stylesContent = useStylesContent();
  const stylesTitle = useStylesTitle();
  return (
    <>
      <div className={styles.root} data-testid="body-text-with-double-cta-fallback-test">
        <BannerCenteredContent isSecondary>
          <div className={classNames(styles.grid, fallbackClassName)}>
            <div className={styles.column}>
              <div className={styles.content}>
                <div className={stylesContent.root}>
                  <div className={stylesTitle.root}>
                    <div className={classNames(stylesTitle.logo, styles.imageRadius)}>
                      <i className="skeleton" />
                    </div>
                    <div className={stylesTitle.textHolder}>
                      <div className={styles.titleFallback}>
                        <i className="skeleton" />
                      </div>
                      <div className={styles.descriptionFallback}>
                        <i className="skeleton" />
                      </div>
                    </div>
                    <div className={stylesTitle.actionsHolder}>
                      <div className={styles.actionFallback}>
                        <i className="skeleton" />
                      </div>
                      <div className={styles.actionFallback}>
                        <i className="skeleton" />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className={styles.descriptionContentFallback}>
                      <i className="skeleton" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={classNames(styles.column, 'image')}>
              <i className="skeleton" />
            </div>
          </div>
        </BannerCenteredContent>
      </div>
    </>
  );
}

export default BodyTextWithDoubleCTAFallback;
